import { Button, Form } from "react-bootstrap";
import { FaLink, FaTimes } from "react-icons/fa";

export const LinkInput = ({
  links,
  onLinkAdd,
  onLinkChange,
  onLinkRemove,
  namePrefix = "links",
  style = {},
}) => {
  return (
    <div style={style}>
      <h6 className="d-flex align-items-center gap-2 mb-2">
        <FaLink /> Project Links
      </h6>
      {links.length > 0 && (
        <div className="mb-2">
          <div
            className="border rounded"
            style={{ maxHeight: "110px", overflowY: "auto" }}
          >
            {links.map((link, index) => (
              <div
                key={index}
                className="d-flex align-items-center justify-content-between p-2 border-bottom gap-2"
              >
                <Form.Control
                  type="text"
                  value={link}
                  onChange={(e) => onLinkChange(index, e.target.value)}
                  placeholder="Link (GitHub, etc.)"
                  size="sm"
                  className="flex-grow-1"
                />
                <Button
                  variant="link"
                  size="sm"
                  onClick={() => onLinkRemove(index)}
                  className="p-0 text-danger"
                  title="Remove link"
                >
                  <FaTimes style={{ fontSize: "10px" }} />
                </Button>
              </div>
            ))}
          </div>
        </div>
      )}
      <div className="d-flex gap-2">
        <Form.Control
          type="text"
          id={`${namePrefix}-new-link`}
          placeholder="Add link (GitHub, etc.)"
          onKeyDown={(e) => {
            const target = e.currentTarget;
            if (e.key === "Enter" && target.value.trim()) {
              onLinkAdd(target.value.trim());
              target.value = "";
            }
          }}
        />
        <Button
          variant="outline-primary"
          onClick={() => {
            const input = document.getElementById(`${namePrefix}-new-link`);
            // check if input has value to add link
            if (input instanceof HTMLInputElement && input.value?.trim()) {
              onLinkAdd(input.value.trim());
              input.value = "";
            }
          }}
          style={{ whiteSpace: "nowrap" }}
        >
          Add Link
        </Button>
      </div>
    </div>
  );
};
